import * as d3 from 'd3';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './PageStructure/Header.js';
import Footer from './PageStructure/Footer.js';
import Hero from './Hero/Hero.js';
import ProjectDetail from './ProjectsPage/ProjectDetail.js'; 
import UkMapWrapper from './UkMapLeaflet/UkMapWrapper.js';
import ProjectsTable from './Table/ProjectsTable.js';
import ApprovedProjects from './ApprovedProjects/ApprovedProjects.js';
import NSIPsDesc from './About/NSIPsDesc.js';
import WhoDidThis from './About/WhoDidThis.js';
import VideoAndDesc from './Video/VideoAndDesc.js';
import { useProjectsData } from './hooks/useProjectsData';

function App() {
  const { data: rawData, loading, error } = useProjectsData();

  const approvedCount = rawData?.filter(
    d => d.ProjectStatus?.trim() === 'Decision' && d.Decision?.trim() === 'Approved'
  ).length || 0;

  const inProgressCount = rawData?.filter(
    d => d.Decision?.trim() === 'In Progress'
  ).length || 0;

  return (
    <Router>
      <div>
        <title>Major Projects Tracker</title>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon_io/favicon-32x32.png"></link>
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon_io/favicon-16x16.png"></link>
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon_io/apple-touch-icon.png"></link>
        <link rel="manifest" href="/favicon_io/site.webmanifest"></link>
      </div>

      <div className="App">
        <Header />
        
        <div className="page">
          <Routes>
            <Route 
              path="/" 
              element={
                <>
                  {error && (
                    <div style={{
                      backgroundColor: '#ffebee',
                      color: '#c62828',
                      padding: '10px',
                      textAlign: 'center',
                      fontSize: '14px',
                      borderBottom: '1px solid #ef9a9a'
                    }}>
                      Unable to load project data. Please try again later.
                    </div>
                  )}
                  <Hero
                    approvedCount={approvedCount}
                    inProgressCount={inProgressCount}
                    targetCount={150}
                  />
                  <VideoAndDesc />
                  <UkMapWrapper data={rawData} />
                  <ApprovedProjects data={rawData} />
                  <NSIPsDesc />
                  <ProjectsTable data={rawData}/> 
                  <WhoDidThis />
                </>
              } 
            />
            
            <Route 
              path="/project/:projectRef" 
              element={
                <ProjectDetail data={rawData} />
              } 
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
